import { useEffect } from 'react';
import { isPwaApp } from '../config/appMode';
import { syncPwaDocumentUi } from '../setupAppMode';
import { PWA_UI_MEDIA_QUERIES } from '../utils/pwaUtils';

function watchPwaUiMediaQueries(onChange) {
  const queries = [
    window.matchMedia(PWA_UI_MEDIA_QUERIES.mobileViewport),
    window.matchMedia(PWA_UI_MEDIA_QUERIES.desktopViewport),
    window.matchMedia(PWA_UI_MEDIA_QUERIES.standalone),
    window.matchMedia(PWA_UI_MEDIA_QUERIES.browser),
    window.matchMedia(PWA_UI_MEDIA_QUERIES.finePointer),
    window.matchMedia(PWA_UI_MEDIA_QUERIES.hoverCapable),
  ];

  queries.forEach((query) => query.addEventListener('change', onChange));

  return () => {
    queries.forEach((query) => query.removeEventListener('change', onChange));
  };
}

/** Syncs title/manifest/classes when viewport or install mode changes. */
function PwaUiSync() {
  useEffect(() => {
    if (!isPwaApp) {
      return undefined;
    }

    const sync = () => syncPwaDocumentUi();

    sync();
    window.addEventListener('resize', sync);
    const unwatchMedia = watchPwaUiMediaQueries(sync);

    return () => {
      window.removeEventListener('resize', sync);
      unwatchMedia();
    };
  }, []);

  return null;
}

export default PwaUiSync;
